import * as types from './constants';

// Billing Add Credits Preview
export const billingAddCreditsPreviewRequest = data => (
  { type: types.BILLING_ADD_CREDITS_PREVIEW_REQUEST, payload: data }
);

export const billingAddCreditsPreviewDone = data => (
  { type: types.BILLING_ADD_CREDITS_PREVIEW_DONE, payload: data }
);

export const billingAddCreditsPreviewFailed = errors => (
  { type: types.BILLING_ADD_CREDITS_PREVIEW_FAILED, payload: errors }
);

export const billingAddCreditsPreviewReset = () => (
  { type: types.BILLING_ADD_CREDITS_PREVIEW_RESET }
);